class BESSAppProjectProfilerDependencyData {

    constructor(data) {
        this.type = data['type'];
        this.questionIdentifier = data['question_identifier'];
        this.questionValue = data['question_value'];
        this.siteTypes = data['site_types'];
        this.editorType = data['editor_type'];
        this.creditCode = data['credit_code'];
        this.dependencyClass =data['dependency_class']
        if('sub_dependency' in data) {
            this.subDependency = new BESSAppProjectProfilerDependencyData(data['sub_dependency']);
        }
    }
}